import axios from "axios";
import { Urls } from "../slices/urls";
import {ServiceUrls} from '../serviceUrl'

// const subDomain = window.location?.host?.split(".")?.splice(1)?.join(".");
// const subDomainName = window.location?.host?.includes("localhost")
//   ? ".careers360.de"
//   : `.${subDomain}`;

export const postSchoolIdpRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_IDP_SCHOOL_API,
    data: data,
  });
};

export const getSchoolIdpStatusRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_ENGINEERING_API,
    params: params,
  });
};
